export default __webpack_public_path__ + "static/desktop_menu_KV01-a662fdc95a418e3bb5dec93ae325aca4.mp4";